import { axios } from "@/libraries/axios";
import type { PostInvitationBodySchema } from "@/schemas";
import type { PostInvitationsResponse } from "@/types";

class InvitationService {
	async invitations(invitation: PostInvitationBodySchema) {
		try {
			const res = await axios.post<PostInvitationsResponse>(
				"/api/v1/invitations",
				invitation,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const invitationService = Object.freeze(new InvitationService());
